import {Component, Input, OnInit} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';

@Component({
  selector: 'app-profile-modal-roles',
  templateUrl: './profile-modal-roles.component.html',
  styleUrls: ['./profile-modal-roles.component.scss']
})
export class ProfileModalRolesComponent implements OnInit {
  @Input() data: { modal: string, data: Object };
  Form: FormGroup;

  constructor(private fb: FormBuilder, private activeModal: NgbActiveModal) {
  }

  ngOnInit(): void {
    this.Form = this.fb.group({
      applicationId: [this.data['data']?.['applicationId'] || null],
      id: [(this.data['modal'] === 'profile' ? this.data['data']?.['idJobSystem'] : this.data['data']['id']) || null],
      description: [this.data['data']?.['description'] || null],
      name: [(this.data['modal'] === 'profile' ? this.data['data']?.['nameJobSystem'] :
        (this.data['modal'] === 'role' ? this.data['data']?.['name'] : null)), [Validators.required]],
      rolId: [this.data['data']?.['rolId'] || null]
    });
    this.validateCase();
  }

  validateCase(): void {
    switch (this.data['modal']) {
      case 'role':
        this.Form.get('description').setValidators([Validators.required]);
        break;
      case 'profile':
        this.Form.get('rolId').setValidators([Validators.required]);
        break;
    }
  }

  send(): void {
    if (this.Form.valid) {
      let form = {...this.Form.value};
      switch (this.data['modal']) {
        case 'role':
          delete form.rolId;
          break;
        case 'profile':
          this.Form.get('rolId').setValidators([Validators.required]);
          delete form.description;
          break;
      }

      !this.data['data']['id'] ? delete form.id : true;
      this.activeModal.close(form);
    }
  }
}
